export default __webpack_public_path__ + "static/media/bobbleLow.0ad608df.svg";